/**
 * Utility Functions
 * Date formatting, wind direction conversions, and general helpers
 */

import { getTimezone } from './config.js';
import { formatForNOAALocal, formatTime as sharedFormatTime, formatDateTime as sharedFormatDateTime, formatCustom } from './time.js';
import { degreesToCompass, compassToDegrees, getDirectionName } from '../shared/direction.mjs';

/**
 * Format date for NOAA API calls (YYYYMMDD)
 */
export function formatDateForAPI(date) {
    return formatForNOAALocal(date);
}

/**
 * Format time/date with locale and timezone
 * Base utility used by formatTime, formatDateTime, etc.
 * Returns '--' for invalid dates
 *
 * Timezone is resolved at call time from the current location — a static
 * timezone here rendered Pacific times for East Coast/Hawaii spots.
 */
export function formatLocalTime(dateInput, options = {}) {
    return formatCustom(dateInput, options, getTimezone());
}

/**
 * Format time for display (e.g., "3:45 PM")
 */
export function formatTime(dateInput) {
    return sharedFormatTime(dateInput, getTimezone());
}

/**
 * Format date and time for display (e.g., "Jan 24, 3:45 PM")
 */
export function formatDateTime(dateInput) {
    return sharedFormatDateTime(dateInput, getTimezone());
}

/**
 * Convert wind direction abbreviation to degrees
 */
export function windDirectionToDegrees(direction) {
    return compassToDegrees(direction);
}

/**
 * Convert degrees to cardinal direction
 */
export function degreesToCardinal(degrees) {
    return degreesToCompass(degrees);
}

/**
 * Get full wind direction name from abbreviation
 */
export function getWindDirectionName(abbr) {
    return getDirectionName(abbr);
}
